<template>
  <div class="@container flex-1 min-w-0 max-w-full flex flex-col gap-3">
    <div class="grid grid-cols-1 @sm:grid-cols-2 @2xl:grid-cols-4 gap-x-4 gap-y-3">
      <div class="@sm:col-span-2">
        <s-input-field
          :id="numberVariableNameId"
          v-model="form.name"
          :label="t('labels.name')"
          :error="errors?.name"
          @update:model-value="update()"
        />
      </div>
    </div>
    <s-form-list
      :title="t('labels.options')"
      :add-label="t('actions.addOption')"
      v-model="form.options"
      :add-item="addOption"
      @update:items="update()"
      removable
    >
      <template #item="{item, index}">
        <div class="p-5">
          <s-textarea-field
            :id="`${optionsId}-${index}`"
            :label="t('labels.optionX', {x: index + 1})"
            v-model="form.options[index]"
            @update:model-value="update()"
          />
        </div>
      </template>
    </s-form-list>
  </div>
</template>

<script setup lang="ts">
import {useId} from 'vue';
import SInputField from '../../../../design-system/SInputField.vue';
import {useForm} from '@inertiajs/vue3';
import STextareaField from '../../../../design-system/STextareaField.vue';
import SFormList from '../../../../design-system/SFormList.vue';
import {useI18n} from 'vue-i18n';

defineProps<{
  errors?: Record<'name' | 'options', string>;
}>();

const numberVariableNameId = useId();
const optionsId = useId();

const name = defineModel<string>('name', {
  default: '',
});
const options = defineModel<string[]>('options', {default: []});

const form = useForm({
  name: name.value,
  options: options.value,
});

const addOption = () => {
  form.options.push('');
  update();
};

const update = () => {
  name.value = form.name;
  options.value = [...form.options];
};

const {t} = useI18n({
  useScope: 'local',
  inheritLocale: true,
});
</script>
<i18n>
{
  "en": {
    "labels.name": "Name",
    "labels.options": "Options",
    "labels.optionX": "Option #{x}",
    "actions.addOption": "Add Option"
  },
  "fr": {
    "labels.name": "Nom",
    "labels.options": "Options",
    "labels.optionX": "Option #{x}",
    "actions.addOption": "Ajouter une option"
  }
}
</i18n>
